import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";

type State = {
  cloneParameter: string | null;
}

type Actions = {
  setCloneParameter: (cloneParameter: State["cloneParameter"]) => void;
}

const initialState: State = {
  cloneParameter: null,
}

export const useGenericStore = create<State & Actions>()(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        ...initialState,
        setCloneParameter: (cloneParameter) => set(() => ({ cloneParameter })),
      }),
      {
        name: process.env.REACT_APP_TOKEN_GENERIC!,
      },
    ),
  ),
);